import React from 'react';
import PropTypes from 'prop-types';

import Review from 'components/reviews/Review';
import { parseAndCleanHtmlToReact } from 'helpers/HtmlHelpers';
import css from 'styles/components/reviews/mostHelpfulReviews.scss';

const MostHelpfulReviews = props => {
  const {
    loadingReviews, onReviewMediaClick, onReviewUpvoteClick, productName,
    reviewSummary, submittedReviews
  } = props;
  const { reviewWithMostVotes, reviewWithLeastVotes } = reviewSummary;

  if (MostHelpfulReviews.shouldRender(reviewSummary)) {
    return (
      <div className={css.container}>
        <div className={css.favorableReview}>
          {reviewWithMostVotes?.overallRating > 0 ? (
            <>
              <h3 className={css.topReviewHeading}>Top Positive Review</h3>
              <Review
                review={reviewWithMostVotes}
                productName={productName}
                forceTabularRatings={true}
                limitSummaryHeight={true}
                loadingReviews={loadingReviews}
                onReviewMediaClick={onReviewMediaClick}
                onReviewUpvoteClick={onReviewUpvoteClick}
                shouldRenderStructuredData={false}
                showFitSurvey={false}
                showMedia={false}
                submittedReviews={submittedReviews} />
            </>
          ) : <h3>Uh oh! No favorable reviews!</h3>}
        </div>
        <span className={css.vsSeparator}><strong>vs</strong></span>
        <div className={css.criticalReview}>
          {reviewWithLeastVotes?.overallRating > 0 ? (
            <>
              <h3 className={css.topReviewHeading}>Top Critical Review</h3>
              <Review
                review={reviewWithLeastVotes}
                productName={productName}
                forceTabularRatings={true}
                limitSummaryHeight={true}
                loadingReviews={loadingReviews}
                onReviewMediaClick={onReviewMediaClick}
                onReviewUpvoteClick={onReviewUpvoteClick}
                shouldRenderStructuredData={false}
                showFitSurvey={false}
                showMedia={false}
                submittedReviews={submittedReviews} />
            </>
          ) : <h3>Woohoo! No critical reviews!</h3>}
        </div>
      </div>
    );
  } else {
    return null;
  }
};

MostHelpfulReviews.shouldRender = reviewSummary => {
  const { reviewWithMostVotes, reviewWithLeastVotes } = reviewSummary;
  return reviewWithMostVotes?.overallRating > 0 && reviewWithLeastVotes?.overallRating > 0;
};

MostHelpfulReviews.defaultProps = {
  isPdp: false
};

MostHelpfulReviews.propTypes = {
  reviewSummary: PropTypes.object.isRequired,
  loadingReviews: PropTypes.array.isRequired,
  onReviewMediaClick: PropTypes.func.isRequired,
  onReviewUpvoteClick: PropTypes.func.isRequired,
  productName: PropTypes.string.isRequired,
  submittedReviews: PropTypes.array.isRequired,
  isPdp: PropTypes.bool.isRequired
};

export default MostHelpfulReviews;
